import { useQuery } from '@tanstack/react-query';
import {
  TARGET_TYPE,
  type TargetTypeType,
} from '@terra/shared-schemas-orchestrator';
import { terraProxyApiClient } from '../../clients/testerClient';

export const AI_COMPONENT_FINDING_COUNTS_KEY = 'ai-component-finding-counts';

const STALE_TIME_MS = 60_000;

export function useAiComponentFindingCounts({
  applicationId,
  targetType = TARGET_TYPE.AI_APPLICATION,
  enabled = true,
}: {
  applicationId: string | null;
  targetType?: TargetTypeType;
  enabled?: boolean;
}) {
  const query = useQuery({
    queryKey: [AI_COMPONENT_FINDING_COUNTS_KEY, applicationId, targetType],
    queryFn: async () => {
      if (!applicationId) {
        return {};
      }

      const response = await terraProxyApiClient.getFindingLinkedAssetCounts({
        targetId: applicationId,
        targetType,
        includeUnpublished: true,
      });

      return response.counts;
    },
    enabled: Boolean(applicationId) && enabled,
    staleTime: STALE_TIME_MS,
  });

  return {
    findingCountsByComponentId: query.data ?? {},
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
